import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import { WButton } from '@wareclouds/wareclouds-ui';

const LeadAccountExistsModal = ({ open }) => {
  const { t } = useTranslation(['onboarding']);
  const navigate = useNavigate();

  const goToLogin = () => {
    navigate('/login');
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
      disableEscapeKeyDown
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            p: 3,
            maxWidth: 400,
          },
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
            <FaceRetouchingNaturalIcon
              sx={{ fontSize: 56, color: 'text.secondary' }}
              aria-hidden
            />
          </Box>

          <Typography
            variant="h5"
            component="h2"
            sx={{ fontWeight: 500, mb: 2, width: '100%' }}
          >
            {t('create_account.modal.lead_already_completed.title')}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: 'text.secondary',
              lineHeight: 1.6,
              width: '100%',
            }}
          >
            {t('create_account.modal.lead_already_completed.description')}
          </Typography>

          <WButton
            label={t('create_account.modal.lead_already_completed.button')}
            variant="contained"
            color="primary"
            fullWidth
            onClick={goToLogin}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LeadAccountExistsModal;
